import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import Badge from '../../../UniformComponents/Badge'
import Button from '../../../UniformComponents/Button'
import Typography from '../../../UniformComponents/Typography'

import './findExhibitor.scss'
import LinkButton from '../../../UniformComponents/LinkButton'
import Input from '../../form/Input'

const searchModule = undefined

const FindExhibitor = observer(({ chartData, onLinkClick }) => {
    const [filteredChartData, setFilteredChartData] = useState(chartData)
    const [searchStr, setSearchStr] = useState('')

    useEffect(() => {
        if (searchStr) {
            setFilteredChartData(chartData?.filter(({ name }) => name?.toLowerCase().includes(searchStr?.toLowerCase())))
        } else {
            setFilteredChartData(chartData)
        }
    }, [searchStr])

    const renderLineItem = (exhibitor) => (
        <div className="exhibitorItem">
            <div className="left">
                <div className="icon">
                    <i className="fa-regular fa-building" />
                </div>
                <div className="exhibitorName">
                    {exhibitor.name}
                </div>
            </div>
            <div className="right">
                <div className="numResponses">
                    {exhibitor.numResponses}
                    {' '}
                    resp
                </div>
                <LinkButton
                    href="/salesIntelligence"
                    onClick={(e) => onLinkClick(e, exhibitor.name)}
                    cssClass="secondary"
                    style={{ height: '28px', padding: '4px 8px', borderRadius: '100px' }}
                    label={(
                        <div className="viewLink">
                            View
                            {' '}
                            <i className="fa-regular fa-arrow-right" />
                        </div>
                    )}
                />
            </div>
        </div>
    )

    return (
        <div className="findExhibitorWidget">
            <div className="widgetTitle">
                <div className="title">Find an Exhibitor</div>
                <div className="subTitle">
                    Select any of the
                    {' '}
                    {chartData?.length}
                    {' '}
                    exhibiting companies to open its full dashboard
                </div>
            </div>
            <hr />
            <div className="searchBox">
                <Input
                    onChange={({ value }) => setSearchStr(value)}
                    placeholder="Search by a company name..."
                />
            </div>
            <div className="instructions">
                <i className="fa-thin fa-hand-point-up" />
                Click a company to drill into its scores, matrix position and feedback
            </div>
            <div className="showing">
                Showing
                {' '}
                {filteredChartData?.length}
                , A-Z
            </div>
            <div className="exhibitors">
                {filteredChartData?.map((ex) => renderLineItem(ex))}
            </div>
        </div>
    )
})

export default FindExhibitor
